module.exports = __webpack_public_path__ + "img/data_box_train.1c51e693.png";